/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CalculatedAttribute } from '@coin/shared/core/util-models-v2';
import { CalculationFormulaResult } from '@coin/shared/core/util-models-v2';
import { ClauseCategory } from '@coin/shared/core/util-models-v2';
import { CountryNumberSetting } from '@coin/shared/core/util-models-v2';
import { CreateCalculatedAttribute } from '@coin/shared/core/util-models-v2';
import { CreateClauseCategory } from '@coin/shared/core/util-models-v2';
import { CreateCountryNumberSetting } from '@coin/shared/core/util-models-v2';
import { CreateDependentAttribute } from '@coin/shared/core/util-models-v2';
import { CreateEclEmployeeAttributeExport } from '@coin/shared/core/util-models-v2';
import { CreateEmployeeAttribute } from '@coin/shared/core/util-models-v2';
import { CreateSignatureAuthorizationSettings } from '@coin/shared/core/util-models-v2';
import { CreateStandardAttribute } from '@coin/shared/core/util-models-v2';
import { DependentAttribute } from '@coin/shared/core/util-models-v2';
import { DependentAttributeValue } from '@coin/shared/core/util-models-v2';
import { EclEmployee } from '@coin/shared/core/util-models-v2';
import { EclSettings } from '@coin/shared/core/util-models-v2';
import { EmployeeAre } from '@coin/shared/core/util-models-v2';
import { EmployeeAttributeDetails } from '@coin/shared/core/util-models-v2';
import { EmployeeAttributeValueTranslation } from '@coin/shared/core/util-models-v2';
import { EmployeeAttributesTranslation } from '@coin/shared/core/util-models-v2';
import { EmployeesUploadedGidsValidationRequest } from '@coin/shared/core/util-models-v2';
import { EntitySearchScope } from '@coin/shared/core/util-models-v2';
import { ListSupportedLanguages } from '@coin/shared/core/util-models-v2';
import { MassTranslateEmployeeAttributes } from '@coin/shared/core/util-models-v2';
import { ModifyDependentAttributeValues } from '@coin/shared/core/util-models-v2';
import { MoveClausesToCategory } from '@coin/shared/core/util-models-v2';
import { PageOfCalculatedAttribute } from '@coin/shared/core/util-models-v2';
import { PageOfClauseCategory } from '@coin/shared/core/util-models-v2';
import { PageOfCountryNumberSetting } from '@coin/shared/core/util-models-v2';
import { PageOfDependentAttribute } from '@coin/shared/core/util-models-v2';
import { PageOfEclEmployee } from '@coin/shared/core/util-models-v2';
import { PageOfEmployeeAttributeDetails } from '@coin/shared/core/util-models-v2';
import { PageOfEmploymentConditionLibraryAresAre } from '@coin/shared/core/util-models-v2';
import { PageOfEmploymentConditionLibraryUsersUser } from '@coin/shared/core/util-models-v2';
import { PageOfSignatureAuthorizationItem } from '@coin/shared/core/util-models-v2';
import { PageOfSignerEmployee } from '@coin/shared/core/util-models-v2';
import { PageOfStandardAttribute } from '@coin/shared/core/util-models-v2';
import { PageOfString } from '@coin/shared/core/util-models-v2';
import { QueryEclEmployeeByRuleSet } from '@coin/shared/core/util-models-v2';
import { ReplaceEmployee } from '@coin/shared/core/util-models-v2';
import { RuleSet } from '@coin/shared/core/util-models-v2';
import { SetUsersAsApprover } from '@coin/shared/core/util-models-v2';
import { SignatureAuthorizationItem } from '@coin/shared/core/util-models-v2';
import { SimulateCalculationFormula } from '@coin/shared/core/util-models-v2';
import { StandardAttribute } from '@coin/shared/core/util-models-v2';
import { StatusResponse } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfExportStatusMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfSimpleStatusMetadata } from '@coin/shared/core/util-models-v2';
import { TranslateEmployeeAttributeValue } from '@coin/shared/core/util-models-v2';
import { UpdateCalculatedAttribute } from '@coin/shared/core/util-models-v2';
import { UpdateClauseCategory } from '@coin/shared/core/util-models-v2';
import { UpdateCountryNumberSetting } from '@coin/shared/core/util-models-v2';
import { UpdateDependentAttribute } from '@coin/shared/core/util-models-v2';
import { UpdateEclSettings } from '@coin/shared/core/util-models-v2';
import { UpdateEmployeeAre } from '@coin/shared/core/util-models-v2';
import { UpdateEmployeeAttribute } from '@coin/shared/core/util-models-v2';
import { UpdateEmployeeAttributeTranslation } from '@coin/shared/core/util-models-v2';
import { UpdateSignatureAuthorizationSettings } from '@coin/shared/core/util-models-v2';
import { UpdateStandardAttribute } from '@coin/shared/core/util-models-v2';
import { UploadedGidsValidationResult } from '@coin/shared/core/util-models-v2';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService, RequestArgs, RequestOptions } from '../api.base.service';

export interface CreateClauseCategoriesParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  createClauseCategory?: CreateClauseCategory;
}

export interface CreateCountryNumberSettingsParams {
  createCountryNumberSetting?: CreateCountryNumberSetting;
}

export interface CreateDependentAttributeAttributesParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  createDependentAttribute?: CreateDependentAttribute;
}

export interface CreateEmployeeAttributesParams {
  employeeId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  createEmployeeAttribute?: CreateEmployeeAttribute;
}

export interface CreateSettingsSignatureAuthorizationsParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  createSignatureAuthorizationSettings?: CreateSignatureAuthorizationSettings;
}

export interface DeleteClauseCategoriesParams {
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface DeleteCountryNumberSettingsParams {
  id: string;
}

export interface DeleteEmployeeAttributesParams {
  employeeId: string;
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface DeleteSettingsSignatureAuthorizationsParams {
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryAdminCreateCalculatedAttributeAttributesParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  createCalculatedAttribute?: CreateCalculatedAttribute;
}

export interface EmploymentConditionLibraryAdminCreateExportEmployeesParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  createEclEmployeeAttributeExport?: CreateEclEmployeeAttributeExport;
}

export interface EmploymentConditionLibraryAdminCreateStandardAttributeAttributesParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  createStandardAttribute?: CreateStandardAttribute;
}

export interface EmploymentConditionLibraryAdminDeleteAttributesParams {
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryAdminGetEmployeesParams {
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryAdminGetFormulaSimulationAttributesParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  simulateCalculationFormula?: SimulateCalculationFormula;
}

export interface EmploymentConditionLibraryAdminGetScopeEmployeesParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryAdminQueryAresParams {
  page?: number;
  size?: number;
  /** The search text to find. */
  name?: string;
  /** The search text to find. */
  areCode?: string;
  /** The search text to find. */
  parentAreCode?: string;
  /** The country\&#39;s ISO2 code to find. */
  countryCode?: string;
  /** The search text to find. */
  searchQuery?: string;
}

export interface EmploymentConditionLibraryAdminQueryByRuleSetEmployeesParams {
  page?: number;
  size?: number;
  module?: 'Default' | 'Restructuring' | 'Playground';
  queryEclEmployeeByRuleSet?: QueryEclEmployeeByRuleSet;
}

export interface EmploymentConditionLibraryAdminQueryCalculatedAttributesAttributesParams {
  country?: Array<string>;
  legalEntity?: Array<string>;
  dataSources?: Array<string>;
  name?: string;
  isPlaceholder?: boolean;
  isRuleRelevant?: boolean;
  isGlobal?: boolean;
  hasPreviousValue?: boolean;
  isMultipleAssignmentAllowed?: boolean;
  effectiveTo?: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  discriminator?: string;
  type?: Array<'Text' | 'Number' | 'Date' | 'Boolean' | 'Country' | 'Currency' | 'Percentage'>;
  interdependencyId?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  module2?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryAdminQueryClauseCategoriesParams {
  type: string;
  searchQuery?: string;
  cluster?: string;
  subject?: string;
  topic?: string;
  queryCountries?: Array<string>;
  queryLegalEntities?: Array<string>;
  queryClusters?: Array<string>;
  querySubjects?: Array<string>;
  queryTopics?: Array<string>;
  queryNames?: Array<string>;
  queryClauseGroups?: Array<string>;
  querySearch?: string;
  queryClauseStatus?: Array<'Draft' | 'Published' | 'Retired' | 'PendingApproval'>;
  queryEffectiveTo?: string;
  queryWithContent?: boolean;
  queryLocalLanguage?: string;
  queryEffectiveFrom?: string;
  queryIsQueryingForTemplate?: boolean;
  queryEffectiveDate?: string;
  categoryQueryClusterValues?: Array<string>;
  categoryQueryClusterType?: string;
  categoryQuerySubjectValues?: Array<string>;
  categoryQuerySubjectType?: string;
  categoryQueryTopicValues?: Array<string>;
  categoryQueryTopicType?: string;
  pageablePage?: number;
  pageableSize?: number;
  parentId?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryAdminQueryEmployeesParams {
  query?: string;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryAdminQueryFieldValueEmployeesParams {
  fieldName: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4;
  gid?: string;
  fullName?: string;
  country?: Array<string>;
  legalEntity?: Array<string>;
  dataSource?: Array<string>;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryAdminQueryFieldValuesAttributesParams {
  fieldName: string;
  country?: Array<string>;
  legalEntity?: Array<string>;
  dataSources?: Array<string>;
  name?: string;
  isPlaceholder?: boolean;
  isRuleRelevant?: boolean;
  isGlobal?: boolean;
  hasPreviousValue?: boolean;
  isMultipleAssignmentAllowed?: boolean;
  effectiveTo?: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  discriminator?: string;
  type?: Array<'Text' | 'Number' | 'Date' | 'Boolean' | 'Country' | 'Currency' | 'Percentage'>;
  interdependencyId?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryAdminQueryStandardAttributesAttributesParams {
  country?: Array<string>;
  legalEntity?: Array<string>;
  dataSources?: Array<string>;
  name?: string;
  isPlaceholder?: boolean;
  isRuleRelevant?: boolean;
  isGlobal?: boolean;
  hasPreviousValue?: boolean;
  isMultipleAssignmentAllowed?: boolean;
  effectiveTo?: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  discriminator?: string;
  type?: Array<'Text' | 'Number' | 'Date' | 'Boolean' | 'Country' | 'Currency' | 'Percentage'>;
  interdependencyId?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  module2?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryAdminQueryUsersParams {
  searchString?: string;
  firstname?: Array<string>;
  lastname?: Array<string>;
  middlename?: Array<string>;
  gid?: Array<string>;
  isApproverAuthorized?: boolean;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryAdminUpdateCalculatedAttributeAttributesParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  updateCalculatedAttribute?: UpdateCalculatedAttribute;
}

export interface EmploymentConditionLibraryAdminUpdateEmployeeAttributesParams {
  employeeId: string;
  updateEmployeeAttribute?: UpdateEmployeeAttribute;
}

export interface EmploymentConditionLibraryAdminUpdateStandardAttributeAttributesParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  updateStandardAttribute?: UpdateStandardAttribute;
}

export interface ExportAresParams {
  /** The search text to find. */
  name?: string;
  /** The search text to find. */
  areCode?: string;
  /** The search text to find. */
  parentAreCode?: string;
  /** The country\&#39;s ISO2 code to find. */
  countryCode?: string;
  /** The search text to find. */
  searchQuery?: string;
}

export interface ExportAttributesParams {
  /** Type of attributes that should be exported. */
  type: 'Standard' | 'Dependent' | 'Calculated';
  country?: Array<string>;
  legalEntity?: Array<string>;
  dataSources?: Array<string>;
  name?: string;
  isPlaceholder?: boolean;
  isRuleRelevant?: boolean;
  isGlobal?: boolean;
  hasPreviousValue?: boolean;
  isMultipleAssignmentAllowed?: boolean;
  effectiveTo?: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  discriminator?: string;
  type2?: Array<'Text' | 'Number' | 'Date' | 'Boolean' | 'Country' | 'Currency' | 'Percentage'>;
  interdependencyId?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  /** ECL Module. */
  module2?: 'Default' | 'Restructuring' | 'Playground';
}

export interface GetCountryNumberSettingsParams {
  countryCode?: string;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface GetEclSettingsParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface GetSimulatedPopulationSignatureAuthorizationsParams {
  id: string;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  ruleSet?: RuleSet;
}

export interface ModifyDependenciesAttributesParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  modifyDependentAttributeValues?: ModifyDependentAttributeValues;
}

export interface MoveClauseToCategoryClauseCategoriesParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  moveClausesToCategory?: MoveClausesToCategory;
}

export interface QueryActualPopulationSignatureAuthorizationsParams {
  id: string;
  pageablePage?: number;
  pageableSize?: number;
  sortableOrderBy?: 'Asc' | 'Desc';
  sortableProperty?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface QueryDependenciesAttributesParams {
  attributeId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface QueryDependentAttributesAttributesParams {
  country?: Array<string>;
  legalEntity?: Array<string>;
  dataSources?: Array<string>;
  name?: string;
  isPlaceholder?: boolean;
  isRuleRelevant?: boolean;
  isGlobal?: boolean;
  hasPreviousValue?: boolean;
  isMultipleAssignmentAllowed?: boolean;
  effectiveTo?: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  discriminator?: string;
  type?: Array<'Text' | 'Number' | 'Date' | 'Boolean' | 'Country' | 'Currency' | 'Percentage'>;
  interdependencyId?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  module2?: 'Default' | 'Restructuring' | 'Playground';
}

export interface QueryEmployeeAttributesParams {
  employeeId: string;
  pageablePage?: number;
  pageableSize?: number;
  sortableOrderBy?: 'Asc' | 'Desc';
  sortableProperty?: string;
  employeeId2?: string;
  attributeName?: Array<string>;
  dataSource?: Array<string>;
  effectiveFrom?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface QueryFieldValuesEmployeeAttributesParams {
  employeeId: string;
  fieldName: string;
  pageablePage?: number;
  pageableSize?: number;
  targetProperty?: 0 | 1 | 2;
  employeeId2?: string;
  attributeName?: Array<string>;
  dataSource?: Array<string>;
  effectiveFrom?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface QueryFieldValuesSignatureAuthorizationsParams {
  queryTargetProperty?: 0;
  queryLegalEntity?: Array<string>;
  pageablePage?: number;
  pageableSize?: number;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface QueryLegalEntityAttributesAttributesParams {
  country?: Array<string>;
  legalEntity?: Array<string>;
  dataSources?: Array<string>;
  name?: string;
  isPlaceholder?: boolean;
  isRuleRelevant?: boolean;
  isGlobal?: boolean;
  hasPreviousValue?: boolean;
  isMultipleAssignmentAllowed?: boolean;
  effectiveTo?: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  discriminator?: string;
  type?: Array<'Text' | 'Number' | 'Date' | 'Boolean' | 'Country' | 'Currency' | 'Percentage'>;
  interdependencyId?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  module2?: 'Default' | 'Restructuring' | 'Playground';
}

export interface QuerySignatureAuthorizationsParams {
  queryTargetProperty?: 0;
  queryLegalEntity?: Array<string>;
  pageablePage?: number;
  pageableSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface RecalculateSettingsSignatureAuthorizationsParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface ReplaceEmployeeEmployeesParams {
  employeeId: string;
  replaceEmployee?: ReplaceEmployee;
}

export interface SetUserAsApproverUsersParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  setUsersAsApprover?: SetUsersAsApprover;
}

export interface TranslateEmployeeAttributeEmployeeAttributeTranslationParams {
  translateEmployeeAttributeValue?: Array<TranslateEmployeeAttributeValue>;
}

export interface TranslateEmployeeAttributesEmployeeAttributeTranslationParams {
  massTranslateEmployeeAttributes?: MassTranslateEmployeeAttributes;
}

export interface UpdateClauseCategoriesParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  updateClauseCategory?: UpdateClauseCategory;
}

export interface UpdateCountryNumberSettingsParams {
  id: string;
  updateCountryNumberSetting?: UpdateCountryNumberSetting;
}

export interface UpdateDependentAttributeAttributesParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  updateDependentAttribute?: UpdateDependentAttribute;
}

export interface UpdateEclSettingsParams {
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  updateEclSettings?: UpdateEclSettings;
}

export interface UpdateEmployeeAresEmployeesParams {
  employeeId: string;
  updateEmployeeAre?: UpdateEmployeeAre;
}

export interface UpdateEmployeeAttributeValuesEmployeeAttributeTranslationParams {
  updateEmployeeAttributeTranslation?: Array<UpdateEmployeeAttributeTranslation>;
}

export interface UpdateLegalEntityAttributeAttributesParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  updateStandardAttribute?: UpdateStandardAttribute;
}

export interface UpdateSettingsSignatureAuthorizationsParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  updateSignatureAuthorizationSettings?: UpdateSignatureAuthorizationSettings;
}

export interface ValidateEmployeesParams {
  employeesUploadedGidsValidationRequest?: EmployeesUploadedGidsValidationRequest;
}

@Injectable({
  providedIn: 'root'
})
export class EmploymentConditionLibraryAdminService extends BaseService {
  constructor(
    httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    super(httpClient, basePath, configuration);
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createClauseCategories(
    requestParameters?: CreateClauseCategoriesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ClauseCategory>;
  public createClauseCategories(
    requestParameters?: CreateClauseCategoriesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ClauseCategory>>;
  public createClauseCategories(
    requestParameters?: CreateClauseCategoriesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ClauseCategory>>;
  public createClauseCategories(
    requestParameters?: CreateClauseCategoriesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/condition-library/admin/v1/clause-categories`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.createClauseCategory,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createCountryNumberSettings(
    requestParameters?: CreateCountryNumberSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<CountryNumberSetting>;
  public createCountryNumberSettings(
    requestParameters?: CreateCountryNumberSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<CountryNumberSetting>>;
  public createCountryNumberSettings(
    requestParameters?: CreateCountryNumberSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<CountryNumberSetting>>;
  public createCountryNumberSettings(
    requestParameters?: CreateCountryNumberSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/condition-library/admin/v1/country-number-settings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createCountryNumberSetting,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createDependentAttributeAttributes(
    requestParameters?: CreateDependentAttributeAttributesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<DependentAttribute>;
  public createDependentAttributeAttributes(
    requestParameters?: CreateDependentAttributeAttributesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<DependentAttribute>>;
  public createDependentAttributeAttributes(
    requestParameters?: CreateDependentAttributeAttributesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<DependentAttribute>>;
  public createDependentAttributeAttributes(
    requestParameters?: CreateDependentAttributeAttributesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/condition-library/admin/v1/attributes/dependent`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.createDependentAttribute,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createEmployeeAttributes(
    requestParameters?: CreateEmployeeAttributesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EmployeeAttributeDetails>;
  public createEmployeeAttributes(
    requestParameters?: CreateEmployeeAttributesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EmployeeAttributeDetails>>;
  public createEmployeeAttributes(
    requestParameters?: CreateEmployeeAttributesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EmployeeAttributeDetails>>;
  public createEmployeeAttributes(
    requestParameters?: CreateEmployeeAttributesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('createEmployeeAttributes', { employeeId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/condition-library/admin/v1/employees/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/attributes`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.createEmployeeAttribute,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createSettingsSignatureAuthorizations(
    requestParameters?: CreateSettingsSignatureAuthorizationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<SignatureAuthorizationItem>;
  public createSettingsSignatureAuthorizations(
    requestParameters?: CreateSettingsSignatureAuthorizationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<SignatureAuthorizationItem>>;
  public createSettingsSignatureAuthorizations(
    requestParameters?: CreateSettingsSignatureAuthorizationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<SignatureAuthorizationItem>>;
  public createSettingsSignatureAuthorizations(
    requestParameters?: CreateSettingsSignatureAuthorizationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/condition-library/admin/v1/signature-authorizations`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.createSignatureAuthorizationSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteClauseCategories(
    requestParameters?: DeleteClauseCategoriesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public deleteClauseCategories(
    requestParameters?: DeleteClauseCategoriesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public deleteClauseCategories(
    requestParameters?: DeleteClauseCategoriesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public deleteClauseCategories(
    requestParameters?: DeleteClauseCategoriesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('deleteClauseCategories', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/condition-library/admin/v1/clause-categories/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: [],
      query: { module: requestParameters?.module }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteCountryNumberSettings(
    requestParameters?: DeleteCountryNumberSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public deleteCountryNumberSettings(
    requestParameters?: DeleteCountryNumberSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public deleteCountryNumberSettings(
    requestParameters?: DeleteCountryNumberSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public deleteCountryNumberSettings(
    requestParameters?: DeleteCountryNumberSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('deleteCountryNumberSettings', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/condition-library/admin/v1/country-number-settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteEmployeeAttributes(
    requestParameters?: DeleteEmployeeAttributesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public deleteEmployeeAttributes(
    requestParameters?: DeleteEmployeeAttributesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public deleteEmployeeAttributes(
    requestParameters?: DeleteEmployeeAttributesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public deleteEmployeeAttributes(
    requestParameters?: DeleteEmployeeAttributesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    const id = requestParameters?.id;
    this.checkRequired('deleteEmployeeAttributes', { employeeId, id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/condition-library/admin/v1/employees/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/attributes/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteSettingsSignatureAuthorizations(
    requestParameters?: DeleteSettingsSignatureAuthorizationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public deleteSettingsSignatureAuthorizations(
    requestParameters?: DeleteSettingsSignatureAuthorizationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public deleteSettingsSignatureAuthorizations(
    requestParameters?: DeleteSettingsSignatureAuthorizationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public deleteSettingsSignatureAuthorizations(
    requestParameters?: DeleteSettingsSignatureAuthorizationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('deleteSettingsSignatureAuthorizations', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/condition-library/admin/v1/signature-authorizations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public employmentConditionLibraryAdminCreateCalculatedAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminCreateCalculatedAttributeAttributesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<CalculatedAttribute>;
  public employmentConditionLibraryAdminCreateCalculatedAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminCreateCalculatedAttributeAttributesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<CalculatedAttribute>>;
  public employmentConditionLibraryAdminCreateCalculatedAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminCreateCalculatedAttributeAttributesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<CalculatedAttribute>>;
  public employmentConditionLibraryAdminCreateCalculatedAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminCreateCalculatedAttributeAttributesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/condition-library/admin/v1/attributes/calculated`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.createCalculatedAttribute,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public employmentConditionLibraryAdminCreateExportEmployees(
    requestParameters?: EmploymentConditionLibraryAdminCreateExportEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public employmentConditionLibraryAdminCreateExportEmployees(
    requestParameters?: EmploymentConditionLibraryAdminCreateExportEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public employmentConditionLibraryAdminCreateExportEmployees(
    requestParameters?: EmploymentConditionLibraryAdminCreateExportEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public employmentConditionLibraryAdminCreateExportEmployees(
    requestParameters?: EmploymentConditionLibraryAdminCreateExportEmployeesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/condition-library/admin/v1/employees/attributes/export`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.createEclEmployeeAttributeExport,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public employmentConditionLibraryAdminCreateStandardAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminCreateStandardAttributeAttributesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StandardAttribute>;
  public employmentConditionLibraryAdminCreateStandardAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminCreateStandardAttributeAttributesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StandardAttribute>>;
  public employmentConditionLibraryAdminCreateStandardAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminCreateStandardAttributeAttributesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StandardAttribute>>;
  public employmentConditionLibraryAdminCreateStandardAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminCreateStandardAttributeAttributesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/condition-library/admin/v1/attributes/standard`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.createStandardAttribute,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public employmentConditionLibraryAdminDeleteAttributes(
    requestParameters?: EmploymentConditionLibraryAdminDeleteAttributesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<boolean>;
  public employmentConditionLibraryAdminDeleteAttributes(
    requestParameters?: EmploymentConditionLibraryAdminDeleteAttributesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<boolean>>;
  public employmentConditionLibraryAdminDeleteAttributes(
    requestParameters?: EmploymentConditionLibraryAdminDeleteAttributesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<boolean>>;
  public employmentConditionLibraryAdminDeleteAttributes(
    requestParameters?: EmploymentConditionLibraryAdminDeleteAttributesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('employmentConditionLibraryAdminDeleteAttributes', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/condition-library/admin/v1/attributes/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public employmentConditionLibraryAdminGetEmployees(
    requestParameters?: EmploymentConditionLibraryAdminGetEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EclEmployee>;
  public employmentConditionLibraryAdminGetEmployees(
    requestParameters?: EmploymentConditionLibraryAdminGetEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EclEmployee>>;
  public employmentConditionLibraryAdminGetEmployees(
    requestParameters?: EmploymentConditionLibraryAdminGetEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EclEmployee>>;
  public employmentConditionLibraryAdminGetEmployees(
    requestParameters?: EmploymentConditionLibraryAdminGetEmployeesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('employmentConditionLibraryAdminGetEmployees', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/admin/v1/employees/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public employmentConditionLibraryAdminGetFormulaSimulationAttributes(
    requestParameters?: EmploymentConditionLibraryAdminGetFormulaSimulationAttributesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<CalculationFormulaResult>;
  public employmentConditionLibraryAdminGetFormulaSimulationAttributes(
    requestParameters?: EmploymentConditionLibraryAdminGetFormulaSimulationAttributesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<CalculationFormulaResult>>;
  public employmentConditionLibraryAdminGetFormulaSimulationAttributes(
    requestParameters?: EmploymentConditionLibraryAdminGetFormulaSimulationAttributesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<CalculationFormulaResult>>;
  public employmentConditionLibraryAdminGetFormulaSimulationAttributes(
    requestParameters?: EmploymentConditionLibraryAdminGetFormulaSimulationAttributesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'put',
      path: `/condition-library/admin/v1/attributes/formula-simulation`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.simulateCalculationFormula,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public employmentConditionLibraryAdminGetScopeEmployees(
    requestParameters?: EmploymentConditionLibraryAdminGetScopeEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EntitySearchScope>;
  public employmentConditionLibraryAdminGetScopeEmployees(
    requestParameters?: EmploymentConditionLibraryAdminGetScopeEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EntitySearchScope>>;
  public employmentConditionLibraryAdminGetScopeEmployees(
    requestParameters?: EmploymentConditionLibraryAdminGetScopeEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EntitySearchScope>>;
  public employmentConditionLibraryAdminGetScopeEmployees(
    requestParameters?: EmploymentConditionLibraryAdminGetScopeEmployeesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/admin/v1/employees/scope`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module }
    });
  }

  /**
   * Queries existing ares by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public employmentConditionLibraryAdminQueryAres(
    requestParameters?: EmploymentConditionLibraryAdminQueryAresParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEmploymentConditionLibraryAresAre>;
  public employmentConditionLibraryAdminQueryAres(
    requestParameters?: EmploymentConditionLibraryAdminQueryAresParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEmploymentConditionLibraryAresAre>>;
  public employmentConditionLibraryAdminQueryAres(
    requestParameters?: EmploymentConditionLibraryAdminQueryAresParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEmploymentConditionLibraryAresAre>>;
  public employmentConditionLibraryAdminQueryAres(
    requestParameters?: EmploymentConditionLibraryAdminQueryAresParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/condition-library/ares`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        Name: requestParameters?.name,
        AreCode: requestParameters?.areCode,
        ParentAreCode: requestParameters?.parentAreCode,
        CountryCode: requestParameters?.countryCode,
        SearchQuery: requestParameters?.searchQuery
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public employmentConditionLibraryAdminQueryByRuleSetEmployees(
    requestParameters?: EmploymentConditionLibraryAdminQueryByRuleSetEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEclEmployee>;
  public employmentConditionLibraryAdminQueryByRuleSetEmployees(
    requestParameters?: EmploymentConditionLibraryAdminQueryByRuleSetEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEclEmployee>>;
  public employmentConditionLibraryAdminQueryByRuleSetEmployees(
    requestParameters?: EmploymentConditionLibraryAdminQueryByRuleSetEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEclEmployee>>;
  public employmentConditionLibraryAdminQueryByRuleSetEmployees(
    requestParameters?: EmploymentConditionLibraryAdminQueryByRuleSetEmployeesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/condition-library/admin/v1/employees/query`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size, module: requestParameters?.module },
      body: requestParameters?.queryEclEmployeeByRuleSet,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public employmentConditionLibraryAdminQueryCalculatedAttributesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminQueryCalculatedAttributesAttributesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfCalculatedAttribute>;
  public employmentConditionLibraryAdminQueryCalculatedAttributesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminQueryCalculatedAttributesAttributesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfCalculatedAttribute>>;
  public employmentConditionLibraryAdminQueryCalculatedAttributesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminQueryCalculatedAttributesAttributesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfCalculatedAttribute>>;
  public employmentConditionLibraryAdminQueryCalculatedAttributesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminQueryCalculatedAttributesAttributesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/admin/v1/attributes/calculated`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Country: requestParameters?.country,
        LegalEntity: requestParameters?.legalEntity,
        DataSources: requestParameters?.dataSources,
        Name: requestParameters?.name,
        IsPlaceholder: requestParameters?.isPlaceholder,
        IsRuleRelevant: requestParameters?.isRuleRelevant,
        IsGlobal: requestParameters?.isGlobal,
        HasPreviousValue: requestParameters?.hasPreviousValue,
        IsMultipleAssignmentAllowed: requestParameters?.isMultipleAssignmentAllowed,
        EffectiveTo: requestParameters?.effectiveTo,
        TargetProperty: requestParameters?.targetProperty,
        Discriminator: requestParameters?.discriminator,
        Type: requestParameters?.type,
        InterdependencyId: requestParameters?.interdependencyId,
        Module: requestParameters?.module,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property,
        module: requestParameters?.module2
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public employmentConditionLibraryAdminQueryClauseCategories(
    requestParameters?: EmploymentConditionLibraryAdminQueryClauseCategoriesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfClauseCategory>;
  public employmentConditionLibraryAdminQueryClauseCategories(
    requestParameters?: EmploymentConditionLibraryAdminQueryClauseCategoriesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfClauseCategory>>;
  public employmentConditionLibraryAdminQueryClauseCategories(
    requestParameters?: EmploymentConditionLibraryAdminQueryClauseCategoriesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfClauseCategory>>;
  public employmentConditionLibraryAdminQueryClauseCategories(
    requestParameters?: EmploymentConditionLibraryAdminQueryClauseCategoriesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const type = requestParameters?.type;
    this.checkRequired('employmentConditionLibraryAdminQueryClauseCategories', { type });
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/admin/v1/clause-categories`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Type: type,
        SearchQuery: requestParameters?.searchQuery,
        Cluster: requestParameters?.cluster,
        Subject: requestParameters?.subject,
        Topic: requestParameters?.topic,
        'Query.Countries': requestParameters?.queryCountries,
        'Query.LegalEntities': requestParameters?.queryLegalEntities,
        'Query.Clusters': requestParameters?.queryClusters,
        'Query.Subjects': requestParameters?.querySubjects,
        'Query.Topics': requestParameters?.queryTopics,
        'Query.Names': requestParameters?.queryNames,
        'Query.ClauseGroups': requestParameters?.queryClauseGroups,
        'Query.Search': requestParameters?.querySearch,
        'Query.ClauseStatus': requestParameters?.queryClauseStatus,
        'Query.EffectiveTo': requestParameters?.queryEffectiveTo,
        'Query.WithContent': requestParameters?.queryWithContent,
        'Query.LocalLanguage': requestParameters?.queryLocalLanguage,
        'Query.EffectiveFrom': requestParameters?.queryEffectiveFrom,
        'Query.IsQueryingForTemplate': requestParameters?.queryIsQueryingForTemplate,
        'Query.EffectiveDate': requestParameters?.queryEffectiveDate,
        'CategoryQuery.Cluster.Values': requestParameters?.categoryQueryClusterValues,
        'CategoryQuery.Cluster.Type': requestParameters?.categoryQueryClusterType,
        'CategoryQuery.Subject.Values': requestParameters?.categoryQuerySubjectValues,
        'CategoryQuery.Subject.Type': requestParameters?.categoryQuerySubjectType,
        'CategoryQuery.Topic.Values': requestParameters?.categoryQueryTopicValues,
        'CategoryQuery.Topic.Type': requestParameters?.categoryQueryTopicType,
        'Pageable.Page': requestParameters?.pageablePage,
        'Pageable.Size': requestParameters?.pageableSize,
        ParentId: requestParameters?.parentId,
        Module: requestParameters?.module
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public employmentConditionLibraryAdminQueryEmployees(
    requestParameters?: EmploymentConditionLibraryAdminQueryEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEclEmployee>;
  public employmentConditionLibraryAdminQueryEmployees(
    requestParameters?: EmploymentConditionLibraryAdminQueryEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEclEmployee>>;
  public employmentConditionLibraryAdminQueryEmployees(
    requestParameters?: EmploymentConditionLibraryAdminQueryEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEclEmployee>>;
  public employmentConditionLibraryAdminQueryEmployees(
    requestParameters?: EmploymentConditionLibraryAdminQueryEmployeesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/admin/v1/employees/query`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        query: requestParameters?.query,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property,
        module: requestParameters?.module
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public employmentConditionLibraryAdminQueryFieldValueEmployees(
    requestParameters?: EmploymentConditionLibraryAdminQueryFieldValueEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<string>>;
  public employmentConditionLibraryAdminQueryFieldValueEmployees(
    requestParameters?: EmploymentConditionLibraryAdminQueryFieldValueEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<string>>>;
  public employmentConditionLibraryAdminQueryFieldValueEmployees(
    requestParameters?: EmploymentConditionLibraryAdminQueryFieldValueEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<string>>>;
  public employmentConditionLibraryAdminQueryFieldValueEmployees(
    requestParameters?: EmploymentConditionLibraryAdminQueryFieldValueEmployeesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const fieldName = requestParameters?.fieldName;
    this.checkRequired('employmentConditionLibraryAdminQueryFieldValueEmployees', { fieldName });
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/admin/v1/employees/field-values/${this.configuration.encodeParam({ name: 'fieldName', value: fieldName, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: requestParameters?.targetProperty,
        Gid: requestParameters?.gid,
        FullName: requestParameters?.fullName,
        Country: requestParameters?.country,
        LegalEntity: requestParameters?.legalEntity,
        DataSource: requestParameters?.dataSource,
        Module: requestParameters?.module
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public employmentConditionLibraryAdminQueryFieldValuesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminQueryFieldValuesAttributesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<string>>;
  public employmentConditionLibraryAdminQueryFieldValuesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminQueryFieldValuesAttributesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<string>>>;
  public employmentConditionLibraryAdminQueryFieldValuesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminQueryFieldValuesAttributesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<string>>>;
  public employmentConditionLibraryAdminQueryFieldValuesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminQueryFieldValuesAttributesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const fieldName = requestParameters?.fieldName;
    this.checkRequired('employmentConditionLibraryAdminQueryFieldValuesAttributes', { fieldName });
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/admin/v1/attributes/field-values/${this.configuration.encodeParam({ name: 'fieldName', value: fieldName, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Country: requestParameters?.country,
        LegalEntity: requestParameters?.legalEntity,
        DataSources: requestParameters?.dataSources,
        Name: requestParameters?.name,
        IsPlaceholder: requestParameters?.isPlaceholder,
        IsRuleRelevant: requestParameters?.isRuleRelevant,
        IsGlobal: requestParameters?.isGlobal,
        HasPreviousValue: requestParameters?.hasPreviousValue,
        IsMultipleAssignmentAllowed: requestParameters?.isMultipleAssignmentAllowed,
        EffectiveTo: requestParameters?.effectiveTo,
        TargetProperty: requestParameters?.targetProperty,
        Discriminator: requestParameters?.discriminator,
        Type: requestParameters?.type,
        InterdependencyId: requestParameters?.interdependencyId,
        Module: requestParameters?.module
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public employmentConditionLibraryAdminQueryStandardAttributesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminQueryStandardAttributesAttributesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfStandardAttribute>;
  public employmentConditionLibraryAdminQueryStandardAttributesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminQueryStandardAttributesAttributesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfStandardAttribute>>;
  public employmentConditionLibraryAdminQueryStandardAttributesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminQueryStandardAttributesAttributesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfStandardAttribute>>;
  public employmentConditionLibraryAdminQueryStandardAttributesAttributes(
    requestParameters?: EmploymentConditionLibraryAdminQueryStandardAttributesAttributesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/admin/v1/attributes/standard`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Country: requestParameters?.country,
        LegalEntity: requestParameters?.legalEntity,
        DataSources: requestParameters?.dataSources,
        Name: requestParameters?.name,
        IsPlaceholder: requestParameters?.isPlaceholder,
        IsRuleRelevant: requestParameters?.isRuleRelevant,
        IsGlobal: requestParameters?.isGlobal,
        HasPreviousValue: requestParameters?.hasPreviousValue,
        IsMultipleAssignmentAllowed: requestParameters?.isMultipleAssignmentAllowed,
        EffectiveTo: requestParameters?.effectiveTo,
        TargetProperty: requestParameters?.targetProperty,
        Discriminator: requestParameters?.discriminator,
        Type: requestParameters?.type,
        InterdependencyId: requestParameters?.interdependencyId,
        Module: requestParameters?.module,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property,
        module: requestParameters?.module2
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public employmentConditionLibraryAdminQueryUsers(
    requestParameters?: EmploymentConditionLibraryAdminQueryUsersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEmploymentConditionLibraryUsersUser>;
  public employmentConditionLibraryAdminQueryUsers(
    requestParameters?: EmploymentConditionLibraryAdminQueryUsersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEmploymentConditionLibraryUsersUser>>;
  public employmentConditionLibraryAdminQueryUsers(
    requestParameters?: EmploymentConditionLibraryAdminQueryUsersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEmploymentConditionLibraryUsersUser>>;
  public employmentConditionLibraryAdminQueryUsers(
    requestParameters?: EmploymentConditionLibraryAdminQueryUsersParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/admin/v1/users`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        SearchString: requestParameters?.searchString,
        Firstname: requestParameters?.firstname,
        Lastname: requestParameters?.lastname,
        Middlename: requestParameters?.middlename,
        Gid: requestParameters?.gid,
        IsApproverAuthorized: requestParameters?.isApproverAuthorized,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property,
        module: requestParameters?.module
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public employmentConditionLibraryAdminUpdateCalculatedAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminUpdateCalculatedAttributeAttributesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<CalculatedAttribute>;
  public employmentConditionLibraryAdminUpdateCalculatedAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminUpdateCalculatedAttributeAttributesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<CalculatedAttribute>>;
  public employmentConditionLibraryAdminUpdateCalculatedAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminUpdateCalculatedAttributeAttributesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<CalculatedAttribute>>;
  public employmentConditionLibraryAdminUpdateCalculatedAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminUpdateCalculatedAttributeAttributesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'patch',
      path: `/condition-library/admin/v1/attributes/calculated`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.updateCalculatedAttribute,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public employmentConditionLibraryAdminUpdateEmployeeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminUpdateEmployeeAttributesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EmployeeAttributeDetails>;
  public employmentConditionLibraryAdminUpdateEmployeeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminUpdateEmployeeAttributesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EmployeeAttributeDetails>>;
  public employmentConditionLibraryAdminUpdateEmployeeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminUpdateEmployeeAttributesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EmployeeAttributeDetails>>;
  public employmentConditionLibraryAdminUpdateEmployeeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminUpdateEmployeeAttributesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('employmentConditionLibraryAdminUpdateEmployeeAttributes', { employeeId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/condition-library/admin/v1/employees/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/attributes`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateEmployeeAttribute,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public employmentConditionLibraryAdminUpdateStandardAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminUpdateStandardAttributeAttributesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StandardAttribute>;
  public employmentConditionLibraryAdminUpdateStandardAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminUpdateStandardAttributeAttributesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StandardAttribute>>;
  public employmentConditionLibraryAdminUpdateStandardAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminUpdateStandardAttributeAttributesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StandardAttribute>>;
  public employmentConditionLibraryAdminUpdateStandardAttributeAttributes(
    requestParameters?: EmploymentConditionLibraryAdminUpdateStandardAttributeAttributesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'patch',
      path: `/condition-library/admin/v1/attributes/standard`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.updateStandardAttribute,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Exports existing ares by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportAres(
    requestParameters?: ExportAresParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportAres(
    requestParameters?: ExportAresParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportAres(
    requestParameters?: ExportAresParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportAres(requestParameters?: ExportAresParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/condition-library/ares/export`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Name: requestParameters?.name,
        AreCode: requestParameters?.areCode,
        ParentAreCode: requestParameters?.parentAreCode,
        CountryCode: requestParameters?.countryCode,
        SearchQuery: requestParameters?.searchQuery
      }
    });
  }

  /**
   * Exports attributes matching the specified query
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportAttributes(
    requestParameters?: ExportAttributesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportAttributes(
    requestParameters?: ExportAttributesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportAttributes(
    requestParameters?: ExportAttributesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportAttributes(requestParameters?: ExportAttributesParams, ...args: RequestArgs): Observable<any> {
    const type = requestParameters?.type;
    this.checkRequired('exportAttributes', { type });
    return this.sendRequest(args, {
      method: 'post',
      path: `/condition-library/admin/v1/attributes/export/${this.configuration.encodeParam({ name: 'type', value: type, in: 'path', style: 'simple', explode: false, dataType: "'Standard' | 'Dependent' | 'Calculated'", dataFormat: undefined })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Country: requestParameters?.country,
        LegalEntity: requestParameters?.legalEntity,
        DataSources: requestParameters?.dataSources,
        Name: requestParameters?.name,
        IsPlaceholder: requestParameters?.isPlaceholder,
        IsRuleRelevant: requestParameters?.isRuleRelevant,
        IsGlobal: requestParameters?.isGlobal,
        HasPreviousValue: requestParameters?.hasPreviousValue,
        IsMultipleAssignmentAllowed: requestParameters?.isMultipleAssignmentAllowed,
        EffectiveTo: requestParameters?.effectiveTo,
        TargetProperty: requestParameters?.targetProperty,
        Discriminator: requestParameters?.discriminator,
        Type: requestParameters?.type2,
        InterdependencyId: requestParameters?.interdependencyId,
        Module: requestParameters?.module,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property,
        module: requestParameters?.module2
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCountryNumberSettings(
    requestParameters?: GetCountryNumberSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfCountryNumberSetting>;
  public getCountryNumberSettings(
    requestParameters?: GetCountryNumberSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfCountryNumberSetting>>;
  public getCountryNumberSettings(
    requestParameters?: GetCountryNumberSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfCountryNumberSetting>>;
  public getCountryNumberSettings(
    requestParameters?: GetCountryNumberSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/admin/v1/country-number-settings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        CountryCode: requestParameters?.countryCode,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property,
        module: requestParameters?.module
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getEclSettings(
    requestParameters?: GetEclSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EclSettings>;
  public getEclSettings(
    requestParameters?: GetEclSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EclSettings>>;
  public getEclSettings(
    requestParameters?: GetEclSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EclSettings>>;
  public getEclSettings(requestParameters?: GetEclSettingsParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/admin/v1/settings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getSimulatedPopulationSignatureAuthorizations(
    requestParameters?: GetSimulatedPopulationSignatureAuthorizationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfSignerEmployee>;
  public getSimulatedPopulationSignatureAuthorizations(
    requestParameters?: GetSimulatedPopulationSignatureAuthorizationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfSignerEmployee>>;
  public getSimulatedPopulationSignatureAuthorizations(
    requestParameters?: GetSimulatedPopulationSignatureAuthorizationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfSignerEmployee>>;
  public getSimulatedPopulationSignatureAuthorizations(
    requestParameters?: GetSimulatedPopulationSignatureAuthorizationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('getSimulatedPopulationSignatureAuthorizations', { id });
    return this.sendRequest(args, {
      method: 'put',
      path: `/condition-library/admin/v1/signature-authorizations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulate-population`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property,
        module: requestParameters?.module
      },
      body: requestParameters?.ruleSet,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getSupportedLanguagesEmployeeAttributeTranslation(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ListSupportedLanguages>;
  public getSupportedLanguagesEmployeeAttributeTranslation(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ListSupportedLanguages>>;
  public getSupportedLanguagesEmployeeAttributeTranslation(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ListSupportedLanguages>>;
  public getSupportedLanguagesEmployeeAttributeTranslation(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/admin/v1/employees/attributes/translation/list-supported-languages`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public modifyDependenciesAttributes(
    requestParameters?: ModifyDependenciesAttributesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<DependentAttributeValue>>;
  public modifyDependenciesAttributes(
    requestParameters?: ModifyDependenciesAttributesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<DependentAttributeValue>>>;
  public modifyDependenciesAttributes(
    requestParameters?: ModifyDependenciesAttributesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<DependentAttributeValue>>>;
  public modifyDependenciesAttributes(
    requestParameters?: ModifyDependenciesAttributesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'put',
      path: `/condition-library/admin/v1/attributes/dependent`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.modifyDependentAttributeValues,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public moveClauseToCategoryClauseCategories(
    requestParameters?: MoveClauseToCategoryClauseCategoriesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public moveClauseToCategoryClauseCategories(
    requestParameters?: MoveClauseToCategoryClauseCategoriesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public moveClauseToCategoryClauseCategories(
    requestParameters?: MoveClauseToCategoryClauseCategoriesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public moveClauseToCategoryClauseCategories(
    requestParameters?: MoveClauseToCategoryClauseCategoriesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'put',
      path: `/condition-library/admin/v1/clause-categories`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.moveClausesToCategory,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryActualPopulationSignatureAuthorizations(
    requestParameters?: QueryActualPopulationSignatureAuthorizationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfSignerEmployee>;
  public queryActualPopulationSignatureAuthorizations(
    requestParameters?: QueryActualPopulationSignatureAuthorizationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfSignerEmployee>>;
  public queryActualPopulationSignatureAuthorizations(
    requestParameters?: QueryActualPopulationSignatureAuthorizationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfSignerEmployee>>;
  public queryActualPopulationSignatureAuthorizations(
    requestParameters?: QueryActualPopulationSignatureAuthorizationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('queryActualPopulationSignatureAuthorizations', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/admin/v1/signature-authorizations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/actual-population`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Pageable.Page': requestParameters?.pageablePage,
        'Pageable.Size': requestParameters?.pageableSize,
        'Sortable.OrderBy': requestParameters?.sortableOrderBy,
        'Sortable.Property': requestParameters?.sortableProperty,
        Module: requestParameters?.module
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryDependenciesAttributes(
    requestParameters?: QueryDependenciesAttributesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<DependentAttributeValue>>;
  public queryDependenciesAttributes(
    requestParameters?: QueryDependenciesAttributesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<DependentAttributeValue>>>;
  public queryDependenciesAttributes(
    requestParameters?: QueryDependenciesAttributesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<DependentAttributeValue>>>;
  public queryDependenciesAttributes(
    requestParameters?: QueryDependenciesAttributesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const attributeId = requestParameters?.attributeId;
    this.checkRequired('queryDependenciesAttributes', { attributeId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/admin/v1/attributes/${this.configuration.encodeParam({ name: 'attributeId', value: attributeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/dependencies`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryDependentAttributesAttributes(
    requestParameters?: QueryDependentAttributesAttributesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfDependentAttribute>;
  public queryDependentAttributesAttributes(
    requestParameters?: QueryDependentAttributesAttributesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfDependentAttribute>>;
  public queryDependentAttributesAttributes(
    requestParameters?: QueryDependentAttributesAttributesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfDependentAttribute>>;
  public queryDependentAttributesAttributes(
    requestParameters?: QueryDependentAttributesAttributesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/admin/v1/attributes/dependent`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Country: requestParameters?.country,
        LegalEntity: requestParameters?.legalEntity,
        DataSources: requestParameters?.dataSources,
        Name: requestParameters?.name,
        IsPlaceholder: requestParameters?.isPlaceholder,
        IsRuleRelevant: requestParameters?.isRuleRelevant,
        IsGlobal: requestParameters?.isGlobal,
        HasPreviousValue: requestParameters?.hasPreviousValue,
        IsMultipleAssignmentAllowed: requestParameters?.isMultipleAssignmentAllowed,
        EffectiveTo: requestParameters?.effectiveTo,
        TargetProperty: requestParameters?.targetProperty,
        Discriminator: requestParameters?.discriminator,
        Type: requestParameters?.type,
        InterdependencyId: requestParameters?.interdependencyId,
        Module: requestParameters?.module,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property,
        module: requestParameters?.module2
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryEmployeeAttributes(
    requestParameters?: QueryEmployeeAttributesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEmployeeAttributeDetails>;
  public queryEmployeeAttributes(
    requestParameters?: QueryEmployeeAttributesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEmployeeAttributeDetails>>;
  public queryEmployeeAttributes(
    requestParameters?: QueryEmployeeAttributesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEmployeeAttributeDetails>>;
  public queryEmployeeAttributes(
    requestParameters?: QueryEmployeeAttributesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('queryEmployeeAttributes', { employeeId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/admin/v1/employees/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/attributes`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Pageable.Page': requestParameters?.pageablePage,
        'Pageable.Size': requestParameters?.pageableSize,
        'Sortable.OrderBy': requestParameters?.sortableOrderBy,
        'Sortable.Property': requestParameters?.sortableProperty,
        EmployeeId: requestParameters?.employeeId2,
        AttributeName: requestParameters?.attributeName,
        DataSource: requestParameters?.dataSource,
        EffectiveFrom: requestParameters?.effectiveFrom,
        Module: requestParameters?.module
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesEmployeeAttributes(
    requestParameters?: QueryFieldValuesEmployeeAttributesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<string>>;
  public queryFieldValuesEmployeeAttributes(
    requestParameters?: QueryFieldValuesEmployeeAttributesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<string>>>;
  public queryFieldValuesEmployeeAttributes(
    requestParameters?: QueryFieldValuesEmployeeAttributesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<string>>>;
  public queryFieldValuesEmployeeAttributes(
    requestParameters?: QueryFieldValuesEmployeeAttributesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    const fieldName = requestParameters?.fieldName;
    this.checkRequired('queryFieldValuesEmployeeAttributes', { employeeId, fieldName });
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/admin/v1/employees/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/attributes/field-values/${this.configuration.encodeParam({ name: 'fieldName', value: fieldName, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Pageable.Page': requestParameters?.pageablePage,
        'Pageable.Size': requestParameters?.pageableSize,
        TargetProperty: requestParameters?.targetProperty,
        EmployeeId: requestParameters?.employeeId2,
        AttributeName: requestParameters?.attributeName,
        DataSource: requestParameters?.dataSource,
        EffectiveFrom: requestParameters?.effectiveFrom,
        Module: requestParameters?.module
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesSignatureAuthorizations(
    requestParameters?: QueryFieldValuesSignatureAuthorizationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public queryFieldValuesSignatureAuthorizations(
    requestParameters?: QueryFieldValuesSignatureAuthorizationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public queryFieldValuesSignatureAuthorizations(
    requestParameters?: QueryFieldValuesSignatureAuthorizationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public queryFieldValuesSignatureAuthorizations(
    requestParameters?: QueryFieldValuesSignatureAuthorizationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/admin/v1/signature-authorizations/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.TargetProperty': requestParameters?.queryTargetProperty,
        'Query.LegalEntity': requestParameters?.queryLegalEntity,
        'Pageable.Page': requestParameters?.pageablePage,
        'Pageable.Size': requestParameters?.pageableSize,
        Module: requestParameters?.module
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryLegalEntityAttributesAttributes(
    requestParameters?: QueryLegalEntityAttributesAttributesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfStandardAttribute>;
  public queryLegalEntityAttributesAttributes(
    requestParameters?: QueryLegalEntityAttributesAttributesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfStandardAttribute>>;
  public queryLegalEntityAttributesAttributes(
    requestParameters?: QueryLegalEntityAttributesAttributesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfStandardAttribute>>;
  public queryLegalEntityAttributesAttributes(
    requestParameters?: QueryLegalEntityAttributesAttributesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/admin/v1/attributes/legal-entity`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Country: requestParameters?.country,
        LegalEntity: requestParameters?.legalEntity,
        DataSources: requestParameters?.dataSources,
        Name: requestParameters?.name,
        IsPlaceholder: requestParameters?.isPlaceholder,
        IsRuleRelevant: requestParameters?.isRuleRelevant,
        IsGlobal: requestParameters?.isGlobal,
        HasPreviousValue: requestParameters?.hasPreviousValue,
        IsMultipleAssignmentAllowed: requestParameters?.isMultipleAssignmentAllowed,
        EffectiveTo: requestParameters?.effectiveTo,
        TargetProperty: requestParameters?.targetProperty,
        Discriminator: requestParameters?.discriminator,
        Type: requestParameters?.type,
        InterdependencyId: requestParameters?.interdependencyId,
        Module: requestParameters?.module,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property,
        module: requestParameters?.module2
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public querySignatureAuthorizations(
    requestParameters?: QuerySignatureAuthorizationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfSignatureAuthorizationItem>;
  public querySignatureAuthorizations(
    requestParameters?: QuerySignatureAuthorizationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfSignatureAuthorizationItem>>;
  public querySignatureAuthorizations(
    requestParameters?: QuerySignatureAuthorizationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfSignatureAuthorizationItem>>;
  public querySignatureAuthorizations(
    requestParameters?: QuerySignatureAuthorizationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/condition-library/admin/v1/signature-authorizations`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.TargetProperty': requestParameters?.queryTargetProperty,
        'Query.LegalEntity': requestParameters?.queryLegalEntity,
        'Pageable.Page': requestParameters?.pageablePage,
        'Pageable.Size': requestParameters?.pageableSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty,
        Module: requestParameters?.module
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recalculateSettingsSignatureAuthorizations(
    requestParameters?: RecalculateSettingsSignatureAuthorizationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfSimpleStatusMetadata>;
  public recalculateSettingsSignatureAuthorizations(
    requestParameters?: RecalculateSettingsSignatureAuthorizationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfSimpleStatusMetadata>>;
  public recalculateSettingsSignatureAuthorizations(
    requestParameters?: RecalculateSettingsSignatureAuthorizationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfSimpleStatusMetadata>>;
  public recalculateSettingsSignatureAuthorizations(
    requestParameters?: RecalculateSettingsSignatureAuthorizationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/condition-library/admin/v1/signature-authorizations/recalculate`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public replaceEmployeeEmployees(
    requestParameters?: ReplaceEmployeeEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public replaceEmployeeEmployees(
    requestParameters?: ReplaceEmployeeEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public replaceEmployeeEmployees(
    requestParameters?: ReplaceEmployeeEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public replaceEmployeeEmployees(
    requestParameters?: ReplaceEmployeeEmployeesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('replaceEmployeeEmployees', { employeeId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/condition-library/admin/v1/employees/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/replace`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.replaceEmployee,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public sendPendingClauseApprovalReminderControllerPendingClauseApprovalReminder(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public sendPendingClauseApprovalReminderControllerPendingClauseApprovalReminder(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public sendPendingClauseApprovalReminderControllerPendingClauseApprovalReminder(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public sendPendingClauseApprovalReminderControllerPendingClauseApprovalReminder(
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/pending-clause-approval-reminder`,
      accepts: []
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public sendPendingTemplateApprovalReminderControllerPendingTemplateApprovalReminder(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public sendPendingTemplateApprovalReminderControllerPendingTemplateApprovalReminder(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public sendPendingTemplateApprovalReminderControllerPendingTemplateApprovalReminder(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public sendPendingTemplateApprovalReminderControllerPendingTemplateApprovalReminder(
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/pending-template-approval-reminder`,
      accepts: []
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public setUserAsApproverUsers(
    requestParameters?: SetUserAsApproverUsersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public setUserAsApproverUsers(
    requestParameters?: SetUserAsApproverUsersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public setUserAsApproverUsers(
    requestParameters?: SetUserAsApproverUsersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public setUserAsApproverUsers(
    requestParameters?: SetUserAsApproverUsersParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'patch',
      path: `/condition-library/admin/v1/users`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.setUsersAsApprover,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public translateEmployeeAttributeEmployeeAttributeTranslation(
    requestParameters?: TranslateEmployeeAttributeEmployeeAttributeTranslationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<EmployeeAttributeValueTranslation>>;
  public translateEmployeeAttributeEmployeeAttributeTranslation(
    requestParameters?: TranslateEmployeeAttributeEmployeeAttributeTranslationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<EmployeeAttributeValueTranslation>>>;
  public translateEmployeeAttributeEmployeeAttributeTranslation(
    requestParameters?: TranslateEmployeeAttributeEmployeeAttributeTranslationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<EmployeeAttributeValueTranslation>>>;
  public translateEmployeeAttributeEmployeeAttributeTranslation(
    requestParameters?: TranslateEmployeeAttributeEmployeeAttributeTranslationParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/condition-library/admin/v1/employees/attributes/translate`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.translateEmployeeAttributeValue,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public translateEmployeeAttributesEmployeeAttributeTranslation(
    requestParameters?: TranslateEmployeeAttributesEmployeeAttributeTranslationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EmployeeAttributesTranslation>;
  public translateEmployeeAttributesEmployeeAttributeTranslation(
    requestParameters?: TranslateEmployeeAttributesEmployeeAttributeTranslationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EmployeeAttributesTranslation>>;
  public translateEmployeeAttributesEmployeeAttributeTranslation(
    requestParameters?: TranslateEmployeeAttributesEmployeeAttributeTranslationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EmployeeAttributesTranslation>>;
  public translateEmployeeAttributesEmployeeAttributeTranslation(
    requestParameters?: TranslateEmployeeAttributesEmployeeAttributeTranslationParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/condition-library/admin/v1/employees/attributes/mass-translate`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.massTranslateEmployeeAttributes,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateClauseCategories(
    requestParameters?: UpdateClauseCategoriesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ClauseCategory>;
  public updateClauseCategories(
    requestParameters?: UpdateClauseCategoriesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ClauseCategory>>;
  public updateClauseCategories(
    requestParameters?: UpdateClauseCategoriesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ClauseCategory>>;
  public updateClauseCategories(
    requestParameters?: UpdateClauseCategoriesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'patch',
      path: `/condition-library/admin/v1/clause-categories`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.updateClauseCategory,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateCountryNumberSettings(
    requestParameters?: UpdateCountryNumberSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<CountryNumberSetting>;
  public updateCountryNumberSettings(
    requestParameters?: UpdateCountryNumberSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<CountryNumberSetting>>;
  public updateCountryNumberSettings(
    requestParameters?: UpdateCountryNumberSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<CountryNumberSetting>>;
  public updateCountryNumberSettings(
    requestParameters?: UpdateCountryNumberSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updateCountryNumberSettings', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/condition-library/admin/v1/country-number-settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateCountryNumberSetting,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateDependentAttributeAttributes(
    requestParameters?: UpdateDependentAttributeAttributesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<DependentAttribute>;
  public updateDependentAttributeAttributes(
    requestParameters?: UpdateDependentAttributeAttributesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<DependentAttribute>>;
  public updateDependentAttributeAttributes(
    requestParameters?: UpdateDependentAttributeAttributesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<DependentAttribute>>;
  public updateDependentAttributeAttributes(
    requestParameters?: UpdateDependentAttributeAttributesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'patch',
      path: `/condition-library/admin/v1/attributes/dependent`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.updateDependentAttribute,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateEclSettings(
    requestParameters?: UpdateEclSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EclSettings>;
  public updateEclSettings(
    requestParameters?: UpdateEclSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EclSettings>>;
  public updateEclSettings(
    requestParameters?: UpdateEclSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EclSettings>>;
  public updateEclSettings(requestParameters?: UpdateEclSettingsParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updateEclSettings', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/condition-library/admin/v1/settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.updateEclSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateEmployeeAresEmployees(
    requestParameters?: UpdateEmployeeAresEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<EmployeeAre>>;
  public updateEmployeeAresEmployees(
    requestParameters?: UpdateEmployeeAresEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<EmployeeAre>>>;
  public updateEmployeeAresEmployees(
    requestParameters?: UpdateEmployeeAresEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<EmployeeAre>>>;
  public updateEmployeeAresEmployees(
    requestParameters?: UpdateEmployeeAresEmployeesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('updateEmployeeAresEmployees', { employeeId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/condition-library/admin/v1/employees/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/update-ares`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateEmployeeAre,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateEmployeeAttributeValuesEmployeeAttributeTranslation(
    requestParameters?: UpdateEmployeeAttributeValuesEmployeeAttributeTranslationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public updateEmployeeAttributeValuesEmployeeAttributeTranslation(
    requestParameters?: UpdateEmployeeAttributeValuesEmployeeAttributeTranslationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public updateEmployeeAttributeValuesEmployeeAttributeTranslation(
    requestParameters?: UpdateEmployeeAttributeValuesEmployeeAttributeTranslationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public updateEmployeeAttributeValuesEmployeeAttributeTranslation(
    requestParameters?: UpdateEmployeeAttributeValuesEmployeeAttributeTranslationParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'patch',
      path: `/condition-library/admin/v1/employees/attributes`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateEmployeeAttributeTranslation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateLegalEntityAttributeAttributes(
    requestParameters?: UpdateLegalEntityAttributeAttributesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StandardAttribute>;
  public updateLegalEntityAttributeAttributes(
    requestParameters?: UpdateLegalEntityAttributeAttributesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StandardAttribute>>;
  public updateLegalEntityAttributeAttributes(
    requestParameters?: UpdateLegalEntityAttributeAttributesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StandardAttribute>>;
  public updateLegalEntityAttributeAttributes(
    requestParameters?: UpdateLegalEntityAttributeAttributesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'patch',
      path: `/condition-library/admin/v1/attributes/legal-entity`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.updateStandardAttribute,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateSettingsSignatureAuthorizations(
    requestParameters?: UpdateSettingsSignatureAuthorizationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<SignatureAuthorizationItem>;
  public updateSettingsSignatureAuthorizations(
    requestParameters?: UpdateSettingsSignatureAuthorizationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<SignatureAuthorizationItem>>;
  public updateSettingsSignatureAuthorizations(
    requestParameters?: UpdateSettingsSignatureAuthorizationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<SignatureAuthorizationItem>>;
  public updateSettingsSignatureAuthorizations(
    requestParameters?: UpdateSettingsSignatureAuthorizationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'patch',
      path: `/condition-library/admin/v1/signature-authorizations`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { module: requestParameters?.module },
      body: requestParameters?.updateSignatureAuthorizationSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public validateEmployees(
    requestParameters?: ValidateEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<UploadedGidsValidationResult>>;
  public validateEmployees(
    requestParameters?: ValidateEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<UploadedGidsValidationResult>>>;
  public validateEmployees(
    requestParameters?: ValidateEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<UploadedGidsValidationResult>>>;
  public validateEmployees(requestParameters?: ValidateEmployeesParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/condition-library/admin/v1/employees/validate-gid-uploads`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.employeesUploadedGidsValidationRequest,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }
}
